package com.eladfinish.bible.contest.screens.mikud.api

import com.eladfinish.bible.contest.network.DefaultApiResult
import com.eladfinish.bible.contest.network.apiTextResult
import io.ktor.client.HttpClient
import io.ktor.client.request.get

interface MikudApi {
    suspend fun getMikudFromServer(): DefaultApiResult<String>
}

class MikudApiImpl(
    private val client: HttpClient,
) : MikudApi {

    companion object {
        private const val REMOTE_FILE = "https://biblecontest-f3b7c.firebaseio.com/mikud-prod.json"
    }

    override suspend fun getMikudFromServer(): DefaultApiResult<String> = apiTextResult {
        client.get(REMOTE_FILE)
    }

}
